<template>
  <div>
    <base-radio-group :class="{ 'no-margin-top': noMarginTop }" :options="options" v-model="localValue"></base-radio-group>
    <b-form-invalid-feedback :state="state">
      {{ errorMsg }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue'

const messages = {
  es: {
    'binary-radio-group': {
      'error-msg': 'Seleccione una opción'
    }
  },
  en: {
    'binary-radio-group': {
      'error-msg': 'Select an option'
    }
  }
}

export default {
  components: {
    'base-radio-group': () => import('@/components/base/forms/BaseRadioGroup'),
    BFormInvalidFeedback
  },
  i18n: {
    messages
  },
  props: {
    value: [String, Object, Boolean],
    options: {
      type: Array,
      required: false,
      default () {
        return [
          { value: true, text: this.$t('yes') },
          { value: false, text: this.$t('no') }
        ]
      }
    },
    state: {
      type: [Boolean, Object],
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('binary-radio-group.error-msg')
      }
    },
    noMarginTop: Boolean
  },
  data () {
    return {
      localValue: null
    }
  },
  created () {
    this.localValue = this.value
    this.$watch('localValue', value => {
      this.$emit('input', value)
    })
  }
}
</script>

<style lang="scss" scoped>
  .no-margin-top{
      margin-top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BinaryRadioGroup.vue